import { render, staticRenderFns } from "./ControlProduct.vue?vue&type=template&id=ca6c41d8&scoped=true&"
import script from "./ControlProduct.vue?vue&type=script&lang=js&"
export * from "./ControlProduct.vue?vue&type=script&lang=js&"
import style0 from "./ControlProduct.vue?vue&type=style&index=0&id=ca6c41d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca6c41d8",
  null
  
)

export default component.exports